export default __webpack_public_path__ + "static/media/img_acca_block_dummy.b83f751f.png";